import { EntityType } from '@frontend/common';
import { PinCodeClient } from '@frontend/pin-code/api';
import { PinCode, UpdatePinCode } from '@frontend/pin-code/types';
import { FormattedMessage } from 'react-intl';

import UpdateModal from '../../../../modal/update-modal/update-modal.component';
import { useUpdateMasterPinCodeModal } from './update-master-pin-code.controller';

export interface UpdateMasterPinCodeModalProps {
    pin_code_id: string;
    callback?: (pinCode: PinCode) => void;
}
export const UpdateMasterPinCodeModal = (props: UpdateMasterPinCodeModalProps) => {
    const viewProps = useUpdateMasterPinCodeModal(props);
    if (!viewProps.pinCode) return null;
    return (
        <UpdateModal<PinCode, UpdatePinCode>
            type={EntityType.IOT}
            label={
                <FormattedMessage
                    id='APPLICATIONS.RAKINDA.UPDATE_MASTER_PIN_CODE'
                    defaultMessage='Update Master PIN-code'
                />
            }
            fieldProps={() => new Map([['code', { maxLength: 4 }]])}
            expectedType={new Map([['code', 'number']])}
            order={['code']}
            values={viewProps.formValues}
            onSubmit={async (value) => {
                try {
                    const pinCode = await PinCodeClient.patchPinCode(viewProps.pinCode!.account_id, viewProps.pinCode!.id, {
                        ...value,
                        code: value.code!.toString()
                    });
                    props.callback && props.callback(pinCode);
                    return pinCode;
                } catch (error) {
                    return Promise.reject(error);
                }
            }}
        />
    );
};
